var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileRepinLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.8 2 4.5 3.5v3L6 8H3.547L3 12.5 2.5 8H0l1.5-1.5v-3L.2 2zM9 0l.5 4.5H12L10.5 6v3l1.3 1.5H6.2L7.5 9V6L6 4.5h2.453z"
})));
export default SvgPinterestMobileRepinLg;